/** The ORCA splash from web-app/index.html — the landing's preloader (logo,
 *  breathing glow, «Анализируем рынок…»). It covers the first frame of every
 *  load, including a reload of a protected page, and dissolves (opacity +
 *  blur) once the session check is done — never a separate «checking» screen.
 *  A minimum display time avoids a one-frame flash on fast loads. */
const MIN_VISIBLE_MS = 700;
const EXIT_MS = 900;
const LANG_KEY = 'orca-web-lang';

export function releasePreloader() {
  const el = document.getElementById('orca-preloader');
  if (!el || el.dataset.leaving) return;
  el.dataset.leaving = '1';
  const wait = Math.max(0, MIN_VISIBLE_MS - performance.now());
  window.setTimeout(() => {
    el.classList.add('out');
    window.setTimeout(() => el.remove(), EXIT_MS);
  }, wait);
}

/** The splash is painted before the app's i18n loads: remember the last
 *  language on this device so its one line is in the user's language. */
export function rememberPreloaderLang(lang: string, text: string) {
  try { localStorage.setItem(LANG_KEY, lang); } catch { /* storage unavailable */ }
  // still on screen (the account's language arrived while it shows): it speaks that language at once
  const line = document.querySelector('#orca-preloader .orca-pl-text');
  if (line) line.textContent = text;
}
